export const getNameClient = () => {
  const storedBrand = localStorage.getItem('brand');
  const brand = storedBrand ? JSON.parse(storedBrand) : {};

  return brand.name ?? 'Innobo';
};
